<template>
    <LoadingVue v-if="isLoading" />
    <div class="events" v-else>
        <TitleCommon :title="$store.state.cart.games.name" :isShowButtonBack="true" />
        <GameEvents v-if="!isNodata" :dataDrawOfTheDay="dataDrawOfTheDay" :dataNextDraws="dataNextDraws" :lengthDraw="lengthDraw" />
        <div v-else class="loto__no-data">
            {{ getTranslatedText('no data') }}
        </div>
    </div>
</template>
<script>
import GameEvents from '@/components/loto/events/index.vue';
import lotoService from '@/services/loto/loto.service';
import LoadingVue from '@/components/common/loading/loading.vue';
import languageMixins from '@/mixins/language-mixins';
import TitleCommon from '@/components/common/title/index.vue';

import { isArrayEmpty, isCurrentToday, isObjEmpty } from '@/utils/utils';

export default {
    mixins: [languageMixins],
    components: { TitleCommon, GameEvents, LoadingVue },
    data() {
        return {
            isLoading: true,
            isNodata: true,
            dataDrawOfTheDay: [],
            dataNextDraws: [],
            lengthDraw: 0,
        };
    },
    created() {
        this.$store.commit('SET_CART_EVENT_EMPTY');
        this.fetchData();
    },
    methods: {
        async fetchData() {
            try {
                if (isObjEmpty(this.$store.state.cart.games)) {
                    const query = this.$route.query;
                    this.$router.push({ path: '/loto-590', query });
                }

                const resp = await lotoService.getListDraw();
                if (resp.code === 200 && !isArrayEmpty(resp.data)) {
                    const game = this.$store.state.cart.games;
                    let dataSource = resp.data.filter((x) => x.game.toLowerCase() === game.type.toLowerCase());

                    this.dataDrawOfTheDay = dataSource.filter((x) => isCurrentToday(x.draw_date));
                    this.dataNextDraws = dataSource.filter((x) => !isCurrentToday(x.draw_date));
                    this.isNodata = isArrayEmpty(this.dataDrawOfTheDay) && isArrayEmpty(this.dataNextDraws);

                    this.lengthDraw = dataSource.length;
                    this.isLoading = false;
                } else {
                    this.isNodata = true;
                    this.isLoading = false;
                }
            } catch (error) {
                console.log(error);
            }
        },
    },
};
</script>

<style lang="scss">
@import '@/public/scss/loto/events.scss';
</style>
